<template>
  <div>
    <Pane />
    <a-card class="container">


      <Padding />
      <a-row style="margin-bottom: 10px;font-size: 15px;">
        {{deptName}}{{year}}年采购汇总清单
      </a-row>
      <a-table
        bordered
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="商品名称" data-index="goodsName"> </a-table-column>
        <a-table-column title="规格型号" data-index="specification"> </a-table-column>
        <a-table-column title="颜色" data-index="color"> </a-table-column>

        <a-table-column title="单位" data-index="unit" align="center">
        </a-table-column>
        <a-table-column title="单价" align="center">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ text.unitPrice }}</span>
          </template>
        </a-table-column>
        <a-table-column title="备注" data-index="priceRemark"> </a-table-column>
        <a-table-column title="采购数量" data-index="salesQuantity"> </a-table-column>
        <a-table-column title="小计">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ text.salesAmount }}</span>
          </template>
        </a-table-column>
      </a-table>  
      <div class="center">
          <a-space>

            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import { fetchApplyList, fetchWareList, downloadDepartmentListFile, fetchDepartmentList } from "@/api/oa/purchaseMaterials";
import { downloadByHtml } from "@/utils/xlsx";
import { saveAs } from "file-saver";
import organization from "@/mixins/organization";
import moment from "moment";
export default {
  name: "materialListDepartment",
  mixins: [watermark,organization],

  data() {
    return {
      active: "tab1",
      form: {},
      loading: false,
      list: [],
      current: 1,
      pageSize: 10,
      listB: [],
      total: 0,
      deptName: "",
      year: "",
    };
  },

  activated() {
    const { query } = this.$route;
    const { year, deptName } = query || {};
    this.year = year;
    this.deptName = deptName;
    this.loading = true;
     fetchDepartmentList(year, deptName)
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res) && Array.isArray(res)) {

            this.list = res
            this.list.push({
              goodsName: "合计",
              specification: "",
              color: "",
              unit: "",
              unitPrice: "",
              priceRemark: "",
              salesQuantity: "",
              salesAmount: this.list.reduce((acc, cur) => acc + (cur.salesAmount || 0), 0),
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
  },

  methods: {
    getList() {
      const { date } = this.form;

      let startTime, endTime;
      if (Array.isArray(date) && date.length === 2) {
        startTime = date[0].format("YYYY-MM-DD");
        endTime = date[1].format("YYYY-MM-DD");
      }

      this.loading = true;
      fetchApplyList(date)
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res) && Array.isArray(res)) {

            this.list = res

          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getListB();
    },
    getListB() {
      const { date,deptId } = this.form;
      let startDate, endDate;
      if (Array.isArray(date) && date.length === 2) {
        startDate = date[0].format("YYYY-MM-DD");
        endDate = date[1].format("YYYY-MM-DD");
      }
      fetchWareList({
        deptId: deptId,
        pageNum: this.current,
        pageSize: this.pageSize,
        startDate,
        endDate,
      })
        .then((res) => {
          this.loading = false;
          this.listB = res.list;
          this.total = res.totalSize ? res.totalSize : 0;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    queryB() {
      this.current = 1;
      this.getListB();
    },
    resetB() {
      this.form = {};
      this.getListB();
    },

    query() {
      this.getList();
    },
    reset() {
      this.form = {};
      this.getList();
    },

    download() {
      downloadDepartmentListFile(this.form.date).then(blob => {
        saveAs(blob, "导出结果.xlsx");
      });
    },

    setPath(record) {
      let url = this.$route.path + "/detail?deptId=" + record.deptId;

      const { date } = this.form;
      let startTime, endTime;
      if (Array.isArray(date) && date.length === 2) {
        startTime = date[0].format("YYYY-MM-DD");
        endTime = date[1].format("YYYY-MM-DD");
        url = `${url}&startTime=${startTime}&endTime=${endTime}`;
      }
      return url;
    },
  },
};
</script>

